export default (translation, translationKey) => {
  const regex = new RegExp('\\[missing "[^"]*' + translationKey.replace(/\./g, '\\.') + '" translation\\]');

  return !translation || regex.test(translation);
};
